import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';
import { utility } from '../../common/utility';
import { ConfirmationService } from 'primeng/api';
import { Router } from '@angular/router';
import { AppBreadcrumbService } from '../../app.breadcrumb.service';

@Component({
  selector: 'app-message-review',
  templateUrl: './message-review.component.html',
  styleUrls: ['./message-review.component.scss']
})
export class MessageReviewComponent implements OnInit {

    constructor(private confirmationService: ConfirmationService,
        private router: Router) { }
    @Input() message: any;
    @Output() reviewBackToEdit = new EventEmitter<string>();
    @Output() reviewCompletedAndSubmit = new EventEmitter<string>();
   
    ngOnInit(): void {       
    }

    backToMessageAdd() {
        this.reviewBackToEdit.emit();
    }

    submiteMessage() {
        this.reviewCompletedAndSubmit.emit();
    }

    formatPhoneNumber(number) {
        return utility.formatPhoneNumber(number);
    }

    getLocation() {
        var result = '';

        if (this.message.StateName != null && this.message.CountryName != null) {
            result = this.message.StateName + ', ' + this.message.CountryName;
        } else if (this.message.StateName != null) {
            result = this.message.StateName
        } else if (this.message.CountryName != null) {
            result = this.message.CountryName;
        }

        return result;
    }

    cancelReview() {
        this.confirmationService.confirm({
            key:"reviewMessageConfirmDialog",
            message: 'Are you sure that you want to Cancel? You will lose all changes made.',
            accept: () => {
                this.router.navigate(['/message/view']);
            }
        });
    }
}
